import { Tag } from '@chakra-ui/react'

export default function ColouredTag ({ colour, size, label, onClick, onClose, children }) {
  return (
    <Tag.Root
      size={size}
      bg={colour}
      color='black'
      _dark={{ bg: 'transparent', color: colour, borderWidth: '1px', borderColor: colour }}
      onClick={onClick}
      cursor={onClick ? 'pointer' : undefined}
    >
      <Tag.Label>{label || children}</Tag.Label>
      {onClose &&
        <Tag.EndElement>
          <Tag.CloseTrigger cursor='pointer' onClick={onClose} />
        </Tag.EndElement>}
    </Tag.Root>
  )
}
